import { Tag, isDefined } from 'common';

import { RETIRED_BLOCK_PROPS_BY_BLOCK_TYPE } from '../../../Configs/retiredBlocks';
import { type ReactFlowBlockNodeProps } from '../types';

interface RetiredBlockDecoratorProps {
  data: ReactFlowBlockNodeProps['data'];
}

export function RetiredBlockDecorator(props: RetiredBlockDecoratorProps) {
  const {
    data: { uiBlockType },
  } = props;
  if (!isDefined(RETIRED_BLOCK_PROPS_BY_BLOCK_TYPE[uiBlockType])) {
    return null;
  }
  return (
    <Tag color="error" sx={{ alignSelf: 'start' }}>
      Update required
    </Tag>
  );
}
